import React from "react";
import { useTheme } from "../../../../contexts/ThemeContext";
import styles from "./NavItem.module.css";

const NavItem = ({ item, isActive, onClick }) => {
  const { isDark } = useTheme();
  const Icon = item.icon;

  return (
    <button
      onClick={onClick}
      className={`${styles.item} ${isActive ? styles.active : ""} ${
        isDark ? styles.dark : ""
      }`}
      aria-current={isActive ? "page" : undefined}
      role="menuitem"
    >
      <span className={styles.icon}>
        <Icon size={20} />
      </span>
      <span className={styles.label}>{item.label}</span>
      {isActive && <span className={styles.indicator} aria-hidden="true" />}
    </button>
  );
};

export default NavItem;
